import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../constants/rentalPortal'
import { EntityStatus } from '../../../Entity'
import {
  getRentalPortalApplicantIdentityLabel,
  RentalPortalApplicantIdentityCell,
} from '../../../RentalPortalApplicant'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import {
  getIsViewingApplicantPreviewable,
  getIsViewingOpenSlot,
  getViewingDateCellDateLabel,
  getViewingTimeRangeLabel,
  RentalPortalViewingDateCell,
  toViewingApplicantIdentity,
  toViewingManagerCellValue,
  VIEWING_COLUMN_NAME,
} from '../../../RentalPortalViewing'
import {
  TableCellBase,
  TableEmptyCell,
  TableTextCell,
  TableUserCell,
} from '../../../Table'

export function getIsViewingRowActive({ activeItem, focusedRow, id }) {
  return focusedRow === id || activeItem === id
}

export function renderViewingCell({
  item,
  locale,
  name,
  t,
  timezone,
  onClickApplicant,
  ...restProps
}) {
  const { [name]: value } = item

  switch (name) {
    case VIEWING_COLUMN_NAME.Listing:
      return (
        <TableTextCell
          {...restProps}
          value={getListingUnitLabel({ listing: item, t })}
        />
      )

    case VIEWING_COLUMN_NAME.DateTime:
      return value ? (
        <RentalPortalViewingDateCell
          {...restProps}
          isFreeSlot={getIsViewingOpenSlot(item)}
          locale={locale}
          start={value}
          timeLabel={getViewingTimeRangeLabel({
            end: item.end,
            locale,
            start: item.start,
            timezone,
          })}
          timezone={timezone}
        />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case VIEWING_COLUMN_NAME.Status:
      return RENTAL_PORTAL_VIEWING_STATUSES[value] ? (
        <TableCellBase {...restProps}>
          <EntityStatus id={value} statuses={RENTAL_PORTAL_VIEWING_STATUSES} />
        </TableCellBase>
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case VIEWING_COLUMN_NAME.Applicant:
      return item.applicant ? (
        <RentalPortalApplicantIdentityCell
          {...restProps}
          applicant={toViewingApplicantIdentity(item.applicant)}
          onClickName={
            getIsViewingApplicantPreviewable(item)
              ? () => onClickApplicant(item)
              : null
          }
        />
      ) : (
        <TableEmptyCell {...restProps} />
      )

    case VIEWING_COLUMN_NAME.Manager:
      return (
        <TableUserCell {...restProps} value={toViewingManagerCellValue(item)} />
      )

    default:
      return <TableEmptyCell {...restProps} />
  }
}

export function getViewingExportValue({ item, locale, name, t, timezone }) {
  const { [name]: value } = item

  switch (name) {
    case VIEWING_COLUMN_NAME.Listing:
      return getListingUnitLabel({ listing: item, t })

    case VIEWING_COLUMN_NAME.DateTime:
      return value
        ? `${getViewingDateCellDateLabel({ locale, start: value, timezone })} ${getViewingTimeRangeLabel({ end: item.end, locale, start: value, timezone })}`
        : null
    case VIEWING_COLUMN_NAME.Status:
      return RENTAL_PORTAL_VIEWING_STATUSES[value]
        ? t(RENTAL_PORTAL_VIEWING_STATUSES[value].text)
        : null
    case VIEWING_COLUMN_NAME.Applicant:
      return item.applicant
        ? getRentalPortalApplicantIdentityLabel({
            applicant: toViewingApplicantIdentity(item.applicant),
            t,
          })
        : null
    default:
      return value
  }
}
